import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-background border-t border-surface py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-20">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-8">
              <div className="w-6 h-6 bg-pacer-gradient rounded-sm transform -skew-x-12"></div>
              <span className="font-lexend font-extrabold text-xl tracking-tighter">PACER<span className="text-pacer-start">APP</span></span>
            </div>
            <p className="font-inter text-[#666] text-sm leading-relaxed mb-8 uppercase tracking-wider">
              REDEFINIENDO EL LÍMITE HUMANO A TRAVÉS DE LA INGENIERÍA DE DATOS Y EL DISEÑO EDITORIAL.
            </p>
            <div className="flex gap-6">
              {['TWITTER', 'INSTAGRAM', 'STRAVA'].map((link) => (
                <a key={link} href="/" className="font-lexend font-bold text-[10px] tracking-[0.2em] text-[#888] hover:text-pacer-start transition-colors">
                  {link}
                </a>
              ))}
            </div>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-2 gap-20">
            <div>
              <h4 className="font-lexend font-bold text-xs tracking-[0.3em] uppercase text-white mb-8">PRODUCTO</h4>
              <ul className="space-y-4">
                <li><Link to="/" className="font-inter text-[#666] text-xs hover:text-white transition-colors">CARACTERÍSTICAS</Link></li>
                <li><Link to="/" className="font-inter text-[#666] text-xs hover:text-white transition-colors">EQUIPOS</Link></li>
                <li><Link to="/" className="font-inter text-[#666] text-xs hover:text-white transition-colors">API</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-lexend font-bold text-xs tracking-[0.3em] uppercase text-white mb-8">LEGAL</h4>
              <ul className="space-y-4">
                <li><Link to="/privacy" className="font-inter text-[#666] text-xs hover:text-white transition-colors">PRIVACY POLICY</Link></li>
                <li><Link to="/" className="font-inter text-[#666] text-xs hover:text-white transition-colors">SUPPORT</Link></li>
                <li><Link to="/terms" className="font-inter text-[#666] text-xs hover:text-white transition-colors">TERMS OF SERVICE</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="flex justify-between items-center pt-8 border-t border-[#1a1a1a]">
          <span className="text-[10px] font-lexend font-bold text-[#444] tracking-[0.2em]">© 2026 PACERAPP DESIGN DEPT.</span>
          <span className="text-[10px] font-lexend font-bold text-[#444] tracking-[0.2em]">BUILT FOR SPEED.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
